import { gql } from "@apollo/client";

export const KONFIR_VERIFICATION_SUBMITTED_MUTATION = gql`
  mutation KonfirVerificationSubmittedMutation($caseId: ID!) {
    konfirVerificationSubmitted(caseId: $caseId) {
      id
    }
  }
`;
